import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Checkbox, Tooltip } from "antd";
import axios from "axios";
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import "./Form.css";
import "../pages/Pages.css";
import PessoaFrame from './PessoaFrame';
import Colors from '../utils/Colors';

const { Column } = Table;

export default class VendaBalcaoCondicioanisForm extends Component {
  state = {
    carregando: false,
    listaRegistros: [],
    registroFiltros: {
      buscaPessoa: { key: '0', },
      buscaTodos: 0,
    },
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.listaRegistros !== propsAnterior.listaRegistros) {
      this.setState({
        carregando: false,
        listaRegistros: [],
        registroFiltros: {
          buscaPessoa: { key: '0' },
          buscaTodos: 0,
        },
      });
    }
  }

  componentDidMount() {

  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [] });
    const { buscaPessoa, buscaTodos } = this.state.registroFiltros;

    if ((buscaPessoa) || (buscaTodos)) {
      this.setState({ carregando: true });

      axios
        .get('/condicional/listaProdutos', {
          params: {
            pessoa: buscaPessoa.key,
            todos: buscaTodos
          }
        })
        .then(response => {
          this.setState({
            listaRegistros: response.data,
            carregando: false,
          });
        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });

    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };

  onOK = () => {
    let registros = [];
    for (var x in this.state.listaRegistros) {

      if (this.state.listaRegistros[x].mi_sit_condicional) {
        registros.push({
          ven_idf: 0,
          venc_idf: this.state.listaRegistros[x].venc_idf,
          mi_idf: 0,
          mi_idf_condicional: this.state.listaRegistros[x].mi_idf,
          mi_item: this.state.listaRegistros[x].mi_item,
          mi_seq: x,
          prod_idf: this.state.listaRegistros[x].mi_item,
          pest_qtde: this.state.listaRegistros[x].mi_seq,
          prod_grade: this.state.listaRegistros[x].prod_grade,
          mi_item_tamanho: this.state.listaRegistros[x].mi_item_tamanho,
          mi_item_cor: this.state.listaRegistros[x].mi_item_cor,
          ptam_descricao: this.state.listaRegistros[x].ptam_descricao,
          pcor_descricao: this.state.listaRegistros[x].pcor_descricao,
          prod_codigo: this.state.listaRegistros[x].prod_codigo,
          prod_descricao: this.state.listaRegistros[x].prod_descricao,
          prod_cod_barras: this.state.listaRegistros[x].prod_cod_barras,
          mi_qtde: this.state.listaRegistros[x].mi_qtde_cond,
          mi_vlr_unit: this.state.listaRegistros[x].mi_vlr_unit,
          mi_vlr_venda: this.state.listaRegistros[x].mi_vlr_venda,
          mi_vlr_venda_min: this.state.listaRegistros[x].mi_vlr_venda_min,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: (this.state.listaRegistros[x].mi_qtde_cond * this.state.listaRegistros[x].mi_vlr_unit).toFixed(2),
          mi_sit_cond: this.state.listaRegistros[x].mi_sit_cond,
          mi_sit_condicional: this.state.listaRegistros[x].mi_sit_condicional,
        });
      }

    }

    let qtdeItens = 0;
    let vlrItens = 0;
    let vlrDesc = 0;
    let vlrAcres = 0;
    let vlrTotal = 0;

    for (var x in registros) {
      qtdeItens = qtdeItens + parseFloat(registros[x].mi_qtde);
      vlrItens = vlrItens + (parseFloat(registros[x].mi_qtde) * parseFloat(registros[x].mi_vlr_unit));
      vlrDesc = vlrDesc + parseFloat(registros[x].mi_vlr_desc);
      vlrAcres = vlrAcres + parseFloat(registros[x].mi_vlr_acres);
      vlrTotal = vlrTotal + parseFloat(registros[x].mi_vlr_total);
    };

    qtdeItens = parseFloat(qtdeItens);
    vlrItens = parseFloat(vlrItens.toFixed(2));
    vlrDesc = parseFloat(vlrDesc.toFixed(2));
    vlrAcres = parseFloat(vlrAcres.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    this.props.onOKCondicionaisClick(
      registros,
      this.state.registroFiltros.buscaPessoa.key,
      this.state.registroFiltros.buscaPessoa.label,
      qtdeItens, vlrItens, vlrDesc, vlrAcres, vlrTotal
    );
  };


  onCarrgarTodosClick = () => {
    this.setState({
      carregando: false,
      listaRegistros: [],
      registroFiltros: {
        buscaPessoa: { key: '0' },
        buscaTodos: 1,
      },
    },
      this.getListaRegistros
    );
  }

  onChangePessoa = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaPessoa'] = event.buscaPessoa;
    registroFiltros['buscaTodos'] = 0;
    this.setState(
      event,
      this.getListaRegistros
    );
  }



  onBaixarClick = (registro) => {
    const mi_idf = registro && registro.mi_idf > 0 ? registro.mi_idf : 0;

    Modal.confirm({
      title: 'Confirmação de Baixa de Condicional',
      content: `Deseja devolver Condicional?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });

        axios.put(`/condicional/retorno/${this.state.registroFiltros.buscaPessoa.key}/${mi_idf}`)
          .then(response => {
            if (mi_idf) {
              const { listaRegistros } = this.state;
              const registroIndex = listaRegistros.findIndex(tar => tar.mi_idf === registro.mi_idf)
              listaRegistros.splice(registroIndex, 1);
              this.setState({
                listaRegistros: listaRegistros.concat([]),
                carregando: false,
              })
            } else {
              this.setState({
                carregando: false,
                listaRegistros: [],
                registroFiltros: {
                  buscaPessoa: { key: '0' },
                  buscaTodos: 0,
                },
              });
            }
          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  }




  renderCheckRetorno = (mi_sit_condicional, registro) => {
    return (
      <Checkbox
        checked={mi_sit_condicional ? true : false}
        onChange={(event) => this.onChangeRetorno(event, registro)}
        disabled={registro.mi_sit_cond ? true : false}
      />
    )
  };

  onChangeRetorno(e, registro) {
    registro.mi_sit_condicional = e.target.checked ? 1 : 0;
    registro.mi_qtde_cond = e.target.checked ? registro.mi_qtde_cond : 0;
    this.forceUpdate();
  }





  renderQtdes = (registro) => {
    return (
      <div>
        <Button type="primary" size="small" disabled={!registro.mi_sit_condicional} onClick={() => this.onQtdeMenosClick(registro)} icon="minus" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }} />
        <span style={{ paddingLeft: 10, paddingRight: 10 }}> {registro.mi_sit_condicional ? registro.mi_qtde_cond : 0} </span>
        <Button type="primary" size="small" disabled={!registro.mi_sit_condicional} onClick={() => this.onQtdeMaisClick(registro)} icon="plus" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }} />
      </div>
    );
  };

  renderBaixar = (registro) => {
    return (
      <div>
        <Tooltip title="Devolver Produto em Condicional" placement="topLeft">
          <Button type="primary" size="small" onClick={() => this.onBaixarClick(registro)} icon="download" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }} />
        </Tooltip>
      </div>
    );
  };

  onQtdeMaisClick = (registro) => {
    if (registro.mi_qtde_cond < registro.mi_qtde) {
      registro.mi_qtde_cond = registro.mi_qtde_cond + 1;
      this.forceUpdate();
    }
  };

  onQtdeMenosClick = (registro) => {
    if (registro.mi_qtde_cond > 1) {
      registro.mi_qtde_cond = registro.mi_qtde_cond - 1;
      this.forceUpdate();
    }
  }



  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderDescricao = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };




  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharClick, visivel } = this.props;
    const { carregando, listaRegistros } = this.state;
    const { buscaPessoa, buscaTodos } = this.state.registroFiltros;

    // console.log('VendaBalcaoCondicioanisForm.this.state', this.state);

    return (
      <Modal
        title={"Selecionar Condicionais"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharClick}
        footer={null}
        width={"70%"}
        style={{ top: 10 }}
      >

        <div>
          <Row>
            <Col xs={10} style={{}}>
              <PessoaFrame
                label=""
                id="buscaPessoa"
                value={buscaPessoa}
                width={"100%"}
                onChange={this.onChangePessoa}
                descricaoPrimeiroItem="Selecione um Cliente"
                tipo={"C"}
              />
            </Col>

            <Col xs={5} style={{ marginTop: 4 }}>
              <Tooltip title="Mostrar Todos os Produtos em Condicional" placement="topLeft">
                <Button
                  type="ghost"
                  icon="reload"
                  onClick={this.onCarrgarTodosClick}
                  className="botao-primary"
                  style={{ width: 150, marginRight: 15, marginLeft: 10 }}
                >
                  Mostrar Todos
                </Button>
              </Tooltip>
            </Col>

            {buscaPessoa && buscaPessoa.key !== '0' && listaRegistros.length > 0 ? (
              <Col xs={5} style={{ width: 200, marginTop: 4, marginLeft: 10 }}>
                <Tooltip title="Devolver Todos os Produto em Condicional" placement="topLeft">
                  <Button
                    type="primary"
                    icon="download"
                    onClick={this.onBaixarClick}
                    className="botao-primary"
                    style={{ width: 200, }}
                  >
                    Devolver Todos
                  </Button>
                </Tooltip>
              </Col>
            ) : null}

          </Row>

          <Row>
            <div style={{ marginTop: 0, height: 300, marginBottom: 25 }}>
              <Table
                pagination={false}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaRegistros}
                scroll={{ y: 280 }}
                rowKey={(registro => registro.mi_idf)}
              >
                {buscaTodos ? (
                  <Column
                    key="pes_nome"
                    dataIndex="pes_nome"
                    title="Cliente"
                    width={150}
                    align="left"
                    className="listaCadastro"
                  />
                ) : null}
                <Column
                  key="prod_codigo"
                  dataIndex="prod_codigo"
                  title="Produto"
                  width={60}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="prod_descricao"
                  dataIndex="prod_descricao"
                  title="Descrição"
                  width={200}
                  align="left"
                  className="listaCadastro"
                  render={this.renderDescricao}
                />
                <Column
                  key="venc_dt_venda"
                  dataIndex="venc_dt_venda"
                  title="Data"
                  render={this.renderData}
                  width={120}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="venc_numero"
                  dataIndex="venc_numero"
                  title="Controle"
                  width={70}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="mi_vlr_unit"
                  dataIndex="mi_vlr_unit"
                  title="Vlr Unit"
                  render={this.renderValor}
                  width={90}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="mi_qtde"
                  dataIndex="mi_qtde"
                  title="Qtde Cond."
                  width={90}
                  align="right"
                  className="listaCadastro"
                />

                {!buscaTodos ? (
                  <Column
                    key="mi_sit_condicional"
                    dataIndex="mi_sit_condicional"
                    title="Venda"
                    render={this.renderCheckRetorno}
                    width={90}
                    align="center"
                  />
                ) : null}
                {!buscaTodos ? (
                  <Column
                    key="qtde"
                    title="Qtde Venda"
                    render={this.renderQtdes}
                    width={130}
                    align="center"
                    className="listaCadastro"
                  />
                ) : null}
                <Column
                  key="baixar"
                  title="Retorno"
                  render={this.renderBaixar}
                  width={80}
                  align="center"
                  className="listaCadastro"
                />
              </Table>
            </div>
          </Row>


          <Row style={{ marginBottom: 20 }}>
            <div className="divider-form" />
            <Col xs={24}>
              {buscaPessoa && buscaPessoa.key !== '0' && listaRegistros.length > 0 ? (
                <Button
                  type="primary"
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  OK
                </Button>
              ) : null}
              <Button
                htmlType="button"
                onClick={onFecharClick}
                className="btn-fechar"
              >
                Fechar
              </Button>
            </Col>
          </Row>
        </div>
      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendaBalcaoCondicioanisForm.js